import AppDashboard from "@/apps/riyasol/Dashboard"
import blogs from "@/apps/riyasol/modules/blogs/blogs.crud"
import experts from "@/apps/riyasol/modules/experts/experts.crud"
import materials from "@/apps/riyasol/modules/materials/materials.crud"
import projects from "@/apps/riyasol/modules/projects/projects.crud"
import rooms from "@/apps/riyasol/modules/projects/submodules/rooms/rooms.crud"
import storeys from "@/apps/riyasol/modules/projects/submodules/storeys/storeys.crud"

import RiyasolIcon from "@/components/icons/RiyasolIcon"
import {
  authProvider,
  dataProvider,
  i18nProvider,
  queryClient,
} from "@/lib/utils/ra.supabase.conf"
import contracts from "@/modules/users/submodules/contracts/contracts.crud"
import permissions from "@/modules/users/submodules/permissions/permissions.crud"
import users from "@/modules/users/users.crud"

const modules = {
  users,
  contracts,
  projects,
  experts,
  storeys,
  rooms,
  blogs,
  materials,
  permissions,
  roles: () => ({
    name: "roles",
    options: { label: "Roles" },
    icon: () => null,
  }),
}
export const providers = {
  authProvider,
  dataProvider,
  i18nProvider,
  queryClient,
}
export const Logo = RiyasolIcon
export const title = "Riyasol Projects Management Platform"
export const Dashboard = AppDashboard
export default modules
